import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Modal,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
  Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Dialog = styled(Modal)`
  &&& {
    padding: 20px 30px;
    width: 480px;
  }
`;

const Content = styled(Modal.Content)`
    background-color: '#fff';
`;

const Header = styled(TextLayoutComponent.Header)`
  font-size: 20px;
  text-align: center;
  padding-bottom: 25px;
  padding-top: 0px;
  font-weight: 500;
  word-break: break-all;
`;

const Button = styled(ButtonLayoutComponent)``;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 25px;
`;

const LoadeComponent = styled(LoaderLayoutComponent)``;

export const ContainerLoader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const Loader = (props) => (
  <ContainerLoader>
    <LoadeComponent size={props.size} data-loader={props.dataLoader} />
  </ContainerLoader>
);

Loader.propTypes = {
  size: PropTypes.string.isRequired,
  dataLoader: PropTypes.string,
};

Loader.defaultProps = {
  dataLoader: '',
};

const ErrorMessage = styled(TextLayoutComponent)`
  color: red;
`;

export {
  Button,
  ContainerButton,
  Content,
  Dialog,
  Header,
  Loader,
  ErrorMessage,
};
